import axios from "axios"
import api from "../api/BaseApi"
//import errorManager from '../utils/ErrorManager';

import {
  ON_USER_SIGN_IN_SUCCESS,
  ON_USER_SIGN_IN_FAIL,
  ON_USER_SIGN_OUT,
  ON_USER_SIGN_IN_REQUEST,
  ON_CREATE_UPDATE_USER_REQUEST,
  ON_UPDATE_USER_SUCCESS,
  ON_CREATE_UPDATE_USER_ERROR,
  CLEAR_USER_STATE,
  CLEAR_REQUEST,
  ON_GET_USERS_LIST_SUCCESS,
  ON_GET_USERS_LIST_FAIL,
  ON_DELETE_USER_SUCCESS,
  ON_DELETE_USER_FAIL,
  CLEAN_USER_FORM,
  ON_CREATE_USER_SUCCESS,
  ON_CREATE_USER_ERROR,
  EDIT_USER_FORM,
  ON_CREATE_USER_REQUEST,
  ON_RESET_PASSWORD_SUCCESS,
  ON_RESET_PASSWORD_FAIL,
  ON_REMOVE_BOUSER_REQUEST,
  ON_REMOVE_BOUSER_SUCCESS,
  ON_REMOVE_BOUSER_ERROR,
  ON_ADD_BOUSER_REQUEST,
  ON_ADD_BOUSER_SUCCESS,
  ON_ADD_BOUSER_ERROR,
} from "./types"

export const onUserSignInRequest = () => {
  return (dispatch) => {
    dispatch({
      type: ON_USER_SIGN_IN_REQUEST,
    })
  }
}

export const onUserSignInClick = (mobile, pwd) => {
  return (dispatch) => {
    axios
      .post(api.signIn, api.signInBody(mobile, pwd))
      .then((res) => {
        const {
          id: userId,
          role,
          accountType,
          firstName,
          lastName,
          token,
          isPasswordTemporary,
          isStrongPassword,
          orderTypeGroup,
          accountTypeId,
        } = res.data

        axios.defaults.headers.common["Authorization"] = `Bearer ${token}` //eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjZmOTE1NDI0LTk0NmMtNGZmMi0xMGNhLTA4ZDZmNTVhNGJlZSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL21vYmlsZXBob25lIjoiMDUyNDI0MDkzNCIsImVtYWlsIjoieXVsaWFnQGVmY29tLmNvLmlsIiwicm9sZSI6Ik1hbmFnZXIiLCJuYmYiOjE1NjEwMjAwOTAsImV4cCI6MTU2MTI3OTI5MCwiaWF0IjoxNTYxMDIwMDkwfQ.x2fDsgYvfhIafL4DnL-U6w7aqxWR4EzsIZ4CVSaL-VM';
        dispatch({
          type: ON_USER_SIGN_IN_SUCCESS,
          payload: {
            userId,
            role,
            accountType,
            firstName,
            lastName,
            token,
            isPasswordTemporary,
            isStrongPassword,
            orderTypeGroup,
            accountTypeId,
          },
        })
        //errorManager.throwDispatchErrorReset(dispatch,res);
      })
      .catch((err) => {
        if (err.message === "Network Error") {
          dispatch({
            type: ON_USER_SIGN_IN_FAIL,
            payload: {
              //errTitle: err.response.data.message,
              //errText: err.response.status
              errTitle: "err_title_text", //'שגיאה',
              errText: "network_error_text", //'תקלת תקשורת זמנית'
            },
          })

          return
        }

        dispatch({
          type: ON_USER_SIGN_IN_FAIL,
          payload: {
            //errTitle: err.response.data.message,
            //errText: err.response.status
            errTitle: "err_title_text", //'שגיאה',
            errText: "wrong_login_err_body_text", //'אחד או יותר מהפרטים שהוזנו שגויים. ניתן לאפס סיסמא באמצעות לחיצה על \'שכחת סיסמא?\''
            // errText: 'הלקוח המבוקש לא קיים, תיתכן שגיאה באחד מהשדות'
          },
        })
      })
  }
}

export const onUserSignOut = () => {
  return (dispatch) => {
    dispatch({
      type: ON_USER_SIGN_OUT,
    })
  }
}

export const updateUserPassword = (updatedUser) => {
  return (dispatch) => {
    dispatch({
      type: ON_CREATE_UPDATE_USER_REQUEST,
    })

    axios
      .put(api.updateUserPassword(), JSON.stringify(updatedUser), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("updateUserData", res)

        dispatch({
          type: ON_UPDATE_USER_SUCCESS,
        })
      })
      .catch((err) => {
        console.log("ERROR AT: updateUserData", err)

        dispatch({
          type: ON_CREATE_UPDATE_USER_ERROR,
        })
      })
  }
}

export const clearUserState = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_USER_STATE,
    })
  }
}

export const clearRequestData = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_REQUEST,
    })
  }
}

export const fetchAllUsers = () => {
  return (dispatch) => {
    axios
      .get(api.getUsersByRole)
      .then((res) => {
        dispatch({
          type: ON_GET_USERS_LIST_SUCCESS,
          payload: res.data,
        })
        console.log("SUCCESS ON GET ALL USERS", res.data)
      })
      .catch((err) => {
        dispatch({
          type: ON_GET_USERS_LIST_FAIL,
          payload: err,
        })
        console.log("FAIL ON GET ALL USERS", err)
      })
  }
}

export const deleteUser = (userId) => {
  return (dispatch) => {
    axios
      .put(api.deleteUser(userId), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("deleteUser", res)

        dispatch({
          type: ON_DELETE_USER_SUCCESS,
        })
      })
      .catch((err) => {
        console.log("ERROR AT: deleteUser", err)

        dispatch({
          type: ON_DELETE_USER_FAIL,
        })
      })
  }
}

export const cleanUserForm = () => {
  return {
    type: CLEAN_USER_FORM,
  }
}

export const createUser = (user) => {
  return (dispatch) => {
    dispatch({
      type: ON_CREATE_USER_REQUEST,
    })

    axios
      .post(api.createUser, JSON.stringify(api.createNewUserBody(user)), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("createNewUser", res.data)
        dispatch({
          type: ON_CREATE_USER_SUCCESS,
          payload: res.data,
        })
      })
      .catch((err) => {
        console.log("ERROR AT: createNewUser", err)
        let errormsg = ""
        if (err.response.status == 409) {
          errormsg = 409
        } else {
          errormsg = err.response ? err.response.data : ""
        }
        dispatch({
          type: ON_CREATE_USER_ERROR,
          payload: errormsg,
        })
      })
  }
}

export const editUserForm = (user) => {
  return {
    type: EDIT_USER_FORM,
    payload: user,
  }
}

export const resetPassword = (userId) => {
  return (dispatch) => {
    axios
      .put(api.resetPassword(userId), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch({
          type: ON_RESET_PASSWORD_SUCCESS,
        })
      })
      .catch((err) => {
        dispatch({
          type: ON_RESET_PASSWORD_FAIL,
        })
      })
  }
}

export const resetBOPassword = (boUserId) => {
  return (dispatch) => {
    axios
      .put(api.resetBOPassword(boUserId), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch({
          type: ON_RESET_PASSWORD_SUCCESS,
        })
      })
      .catch((err) => {
        dispatch({
          type: ON_RESET_PASSWORD_FAIL,
        })
      })
  }
}

export const addBOUser = (userId, role, accountType) => {
  return (dispatch) => {
    dispatch({
      type: ON_ADD_BOUSER_REQUEST,
    })

    axios
      .put(api.addBOUser(userId, role, accountType), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("addBOUser", res.data)
        dispatch({
          type: ON_ADD_BOUSER_SUCCESS,
          payload: res.data,
        })
      })
      .catch((err) => {
        console.log("ERROR AT: addBOUser", err)
        let errormsg = ""
        if (err.response.status == 409) {
          errormsg = 409
        } else {
          errormsg = err.response ? err.response.data : ""
        }
        dispatch({
          type: ON_ADD_BOUSER_ERROR,
          payload: errormsg,
        })
      })
  }
}

export const RemoveBOUser = (userId, role, accountType) => {
  return (dispatch) => {
    dispatch({
      type: ON_REMOVE_BOUSER_REQUEST,
    })

    axios
      .put(api.removeBOUser(userId, role, accountType), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("removeBOUser", res.data)
        dispatch({
          type: ON_REMOVE_BOUSER_SUCCESS,
          payload: res.data,
        })
      })
      .catch((err) => {
        console.log("ERROR AT: removeBOUser", err)
        let errormsg = ""
        if (err.response.status == 409) {
          errormsg = 409
        } else {
          errormsg = err.response ? err.response.data : ""
        }
        dispatch({
          type: ON_REMOVE_BOUSER_ERROR,
          payload: errormsg,
        })
      })
  }
}
